module.exports = __webpack_public_path__ + "static/media/pre-wedding-fun-alt.f3179715.svg";